import { render, staticRenderFns } from "./fourTest.vue?vue&type=template&id=75635b9b&scoped=true"
import script from "./fourTest.vue?vue&type=script&lang=js"
export * from "./fourTest.vue?vue&type=script&lang=js"
import style0 from "./fourTest.vue?vue&type=style&index=0&id=75635b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75635b9b",
  null
  
)

export default component.exports